import { createContext } from 'react';

import { UserAccessRight } from 'apis/restaurant-api/merchant-admin/user/types';

export default createContext<UserAccessRight[]>([]);
